import styled from "styled-components";
import { NumericFormat } from "react-number-format";

export const NumericFormatInput = styled(NumericFormat)`
    width: 100%;
    height: 100%;
    border: none;
    font-size: 0.875rem;
    padding: 0 10px;
`;